/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_MoreInputs */

const en_portalframe_more = /** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const ar_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const he_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const ur_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const es_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const fr_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const de_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const pt_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const hi_portalframe_more = en_portalframe_more;

/** @type {(inputs: Portalframe_MoreInputs) => LocalizedString} */
const bn_portalframe_more = en_portalframe_more;

/**
* | output |
* | --- |
* | "More" |
*
* @param {Portalframe_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_more = /** @type {((inputs?: Portalframe_MoreInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_MoreInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_more(inputs)
	if (locale === "he") return he_portalframe_more(inputs)
	if (locale === "ur") return ur_portalframe_more(inputs)
	if (locale === "es") return es_portalframe_more(inputs)
	if (locale === "fr") return fr_portalframe_more(inputs)
	if (locale === "de") return de_portalframe_more(inputs)
	if (locale === "pt") return pt_portalframe_more(inputs)
	if (locale === "hi") return hi_portalframe_more(inputs)
	if (locale === "bn") return bn_portalframe_more(inputs)
	return /** @type {LocalizedString} */ ("More")
});